var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$parent.$options._componentTag === 'm-top-app-bar')?_c('button',_vm._g({staticClass:"material-icons"},_vm.$listeners),[_vm._v(" "+_vm._s(_vm.icon)+" ")]):(
    _vm.$parent.$options._componentTag === 'm-list-item' ||
      _vm.$parent.$options._componentTag === 'm-tab'
  )?_c('span',_vm._g({staticClass:"material-icons"},_vm.$listeners),[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_c('i',_vm._g({staticClass:"material-icons"},_vm.$listeners),[_vm._v(" "+_vm._s(_vm.icon)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }